const getters = {
  voiceCampaignsAgent(state) {
    return state.campaignsAgent;
  },
};

export default getters;
